import { forwardRef, useState } from "react";
import { cn } from "../lib/utils";

export interface ColorSelectorProps extends React.ComponentProps<"button"> {
  color?: string;
}

export const ColorSelector = forwardRef<HTMLButtonElement, ColorSelectorProps>(
  ({ className, color = "#000000", ...props }, ref) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <button
        ref={ref}
        className={cn(
          "relative transition-all outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
          "size-4 rounded-full", // 16x16 for the solid circle, make button itself round
          className
        )}
        style={{ backgroundColor: color }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        {...props}
      >
        {/* Hover ring - 24x24 grey ring around the circle */}
        {isHovered && (
          <div className="absolute inset-0 rounded-full border-2 border-muted-foreground/30 size-6 -translate-x-1 -translate-y-1" />
        )}
      </button>
    );
  }
);

ColorSelector.displayName = "ColorSelector";
